// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__XkdFt","requiredAsterisk":"Info_requiredAsterisk__uRKt5"};